import React, { FC } from 'react';

interface Props {
  text: string;
  url: string;
  title: string;
  className: string;
  openInNewWindow?: boolean;
}

const QuickLink: FC<Props> = ({ text, url, title, className, children }) => {
  return (
    <>
      <li className={`f2-quicklinks__item ${className}`}>
        <a href={url} title={title} className="f2-quicklinks__content">
          <p className="f2-quicklinks__text">{text.toUpperCase()}</p>
          {children}
        </a>
      </li>
    </>
  );
};

export default QuickLink;
